module.exports = __webpack_public_path__ + "media/images/icon-unlock-outline-a7b9d581258dd79b185d9fbfb6e80cc1.svg";